import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchVisites = createAsyncThunk("visites/fetchAll", async ({ page = 1, pageSize = 10 } = {}, { rejectWithValue }) => {
  try { const r = await api.get('/VisiteTechnique', { params: { page, pageSize } }); return r.data; } // PagedResult
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const createVisite = createAsyncThunk("visites/create", async (data, { rejectWithValue }) => {
  try {
    await api.post('/VisiteTechnique', data);
    const list = await api.get('/VisiteTechnique', { params: { page: 1, pageSize: 10 } });
    return list.data; // PagedResult
  } catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const updateVisite = createAsyncThunk("visites/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    await api.patch(`/VisiteTechnique/${id}`, data);
    const list = await api.get('/VisiteTechnique', { params: { page: 1, pageSize: 10 } });
    return list.data; // PagedResult
  }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const deleteVisite = createAsyncThunk("visites/delete", async (id, { rejectWithValue }) => {
  try { await api.delete(`/VisiteTechnique/${id}`); return id; }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

const pagedFulfilled = (state, action) => {
  state.loading = false;
  state.items = action.payload.items;
  state.totalCount = action.payload.totalCount;
  state.totalPages = action.payload.totalPages;
  state.currentPage = action.payload.page ?? 1;
  state.success = true;
};

const slice = createSlice({
  name: "visites",
  initialState: {
    items: [],
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetSuccess: (state) => { state.success = false; },
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVisites.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchVisites.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(fetchVisites.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(createVisite.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(createVisite.fulfilled, (state, action) => { pagedFulfilled(state, action); state.currentPage = 1; })
      .addCase(createVisite.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(updateVisite.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(updateVisite.fulfilled, (state, action) => { pagedFulfilled(state, action); state.currentPage = 1; })
      .addCase(updateVisite.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(deleteVisite.fulfilled, (state, action) => {
        state.items = state.items.filter(i => i.id !== action.payload);
        state.totalCount = Math.max(0, state.totalCount - 1);
        state.success = true;
      })
      .addCase(deleteVisite.rejected, (state, action) => { state.error = action.payload; });
  },
});

export const { resetSuccess, clearError } = slice.actions;
export default slice.reducer;
